import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './redux/store/store';
import { AnimatePresence } from 'framer-motion';
import { setupAppAccessInterceptor } from './service/appAccessInterceptor';

setupAppAccessInterceptor();

const root = ReactDOM.createRoot(
    document.getElementById('root'),
);
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <AnimatePresence>
                <App />
            </AnimatePresence>
        </BrowserRouter>
    </Provider>,
);
reportWebVitals();
